<template>
  <div class="tips" :class="{ open }">
    <button type="button" class="tips-toggle" @click="open = !open">
      <v-icon size="18" class="tips-chevron">mdi-chevron-right</v-icon>
      <v-icon size="16" color="#64ffda">mdi-lightbulb-on-outline</v-icon>
      <span class="tips-title">Tips for a good capture</span>
      <span class="tips-fyi">FYI</span>
    </button>

    <v-expand-transition>
      <div v-show="open" class="tips-body">
        <div class="tips-grid">
          <div v-for="g in groups" :key="g.title" class="tips-card">
            <div class="tips-card-title">{{ g.title }}</div>
            <div v-for="it in g.items" :key="it.label" class="tips-item">
              <span class="tips-dot"></span>
              <div class="tips-item-body">
                <div class="tips-item-label">{{ it.label }}</div>
                <div class="tips-item-hint">{{ it.hint }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { MANUAL_GROUPS } from '@/constants/captureQuality';

export default {
  name: 'CaptureTips',
  data() {
    return { open: false, groups: MANUAL_GROUPS };
  },
};
</script>

<style scoped>
.tips {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  overflow: hidden;
}
.tips-toggle {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 11px 14px; background: none; border: none; cursor: pointer;
  font: inherit; color: #d6e4ea; text-align: left;
}
.tips-toggle:hover { background: rgba(255, 255, 255, 0.03); }
.tips-chevron { transition: transform 0.2s ease; color: #8aa0aa; }
.tips.open .tips-chevron { transform: rotate(90deg); }
.tips-title { font-size: 0.84rem; font-weight: 600; }
.tips-fyi {
  margin-left: auto; font-size: 0.64rem; font-weight: 700; letter-spacing: 0.06em;
  color: #8aa0aa; background: rgba(255, 255, 255, 0.06); padding: 1px 7px; border-radius: 9999px;
}

.tips-body { padding: 14px; }
.tips-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 12px; }
.tips-card {
  padding: 12px 14px; border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
}
.tips-card-title { font-size: 0.8rem; font-weight: 700; color: #d6e4ea; margin-bottom: 8px; }
.tips-item { display: flex; gap: 8px; padding: 4px 0; }
.tips-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--duallo-accent); margin-top: 7px; flex: 0 0 auto; }
.tips-item-body { min-width: 0; }
.tips-item-label { font-size: 0.82rem; font-weight: 600; color: #e6edf0; }
.tips-item-hint { font-size: 0.74rem; color: #8aa0aa; line-height: 1.3; }
</style>
